import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import App from './Component/App'
import Phi from '../../Phi/Phi'

const mapStateToProps = (state, ownProps) => {
  
    return {

      isGuestLogin: Phi.User.isGuest(),

      isMagicLinkUsed: state.auth.isMagicLinkUsed,
      isMagicLinkSuccess: state.auth.isMagicLinkUsed,
      magicLinkMeta: state.auth.magicLinkMeta || {},

      isLoading: state.auth.isLoading,
      isComponentLoading: state.auth.isComponentLoading,
      currentChildId: state.auth.currentStudentId,

      setPassword: state.auth.setPassword,

      user: state.auth.userProfile,

      childList: state.child.childList || [],
      childCurrent: state.child.selectedChild || 0,

      isInvitationLinkUsed: state.auth.isInvitationLinkUsed,
      isInvitationLinkSuccess: state.auth.isInvitationLinkSuccess,
      isInvitationLinkFailed: state.auth.isInvitationLinkFailed,
      showInvitationLinkModal: state.auth.showInvitationLinkModal,
      allowInvitationLinkUpdate: state.auth.allowInvitationLinkUpdate,
      invitationLink: state.auth.invitationLink,
      invitationLinkUpdate: state.auth.invitationLinkUpdate,

      showModalUserProfile: state.auth.openUserProfile,

      emailVerified: state.auth.emailVerified,
      emailAvailable: state.auth.ckeckEmailStatus,

      checkValidationResponseType: state.auth.checkValidationResponseType,

      s3AccessResponse: state.metaData.s3Access || {},

      sidebar: state.auth.showSideBar,
      totalCovidData:state.organization.totalCovidData,
      modalTypeHandler: state.auth.modalType


    }
}

const mapDispatchToProps = (dispatch) => {
    return {

      getUser: () => dispatch(Actions.getUser()),
      fetchChildList: (userId, studentId) => dispatch(Actions.fetchChildList({ userId, studentId })),
      changePassword: (newPassword) => dispatch(Actions.changePassword(newPassword, true)),
      invitationRequestSuccess: (invitationLink) => dispatch(Actions.putInvitationRequestSuccess(invitationLink)),

      toggleUserProfileModal: (flag, modalType) => dispatch(Actions.changeUserProfileModalState(flag, modalType)),

      checkEmailAvailability: (email) => dispatch(Actions.checkEmailAvailability(email)),
      changeValidationResponseType: (str) => dispatch(Actions.changeValidationResponseType(str)),

      updateUserProfile: (payload) => dispatch(Actions.updateUserProfile(payload)),
      s3Access: () => dispatch(Actions.getS3Access()),
      getCovidGlobalDashboard: (state, city) => dispatch(Actions.getCovidGlobalDashboard(state, city)),
      postUserLocation: (location) => dispatch(Actions.changeUserLocation(location)),


    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)

